module.exports = __webpack_public_path__ + "813c2fc0bc9d61d358e8a0b3e3795138.svg";